import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "app/auth/authRoles";
import { Navigate } from "react-router-dom";

const UserManagement = Loadable(lazy(() => import("./UserManagement")));
const RoleManagement = Loadable(lazy(() => import("./RoleManagement")));
const DataManagement = Loadable(lazy(() => import("./DataManagement")));
const TimekeepingManagement = Loadable(
  lazy(() => import("./TimekeepingManagement")),
);
const AttendanceManagement = Loadable(
  lazy(() => import("./AttendanceManagement")),
);

const maintenanceRoutes = [
  {
    path: "/Usermanagement",
    element: <Navigate to="/Maintenance/Usermanagement" />,
    auth: authRoles.adminhr,
  },
  {
    path: "/Rolemanagement",
    element: <Navigate to="/Maintenance/Rolemanagement" />,
    auth: authRoles.admin,
  },
  {
    path: "/Datamanagement",
    element: <Navigate to="/Maintenance/Datamanagement" />,
    auth: authRoles.adminhr,
  },
  {
    path: "/Timekeepingmanagement",
    element: <Navigate to="/Maintenance/TimekeepingManagement" />,
    auth: authRoles.adminhr,
  },
  {
    path: "/Attendancemanagement",
    element: <Navigate to="/Maintenance/Attendancemanagement" />,
    auth: authRoles.adminhr,
  },
  {
    path: "/Maintenance/Usermanagement",
    element: <UserManagement />,
    auth: authRoles.adminhr,
  },
  {
    path: "/Maintenance/Rolemanagement",
    element: <RoleManagement />,
    auth: authRoles.admin,
  },
  {
    path: "/Maintenance/Datamanagement",
    element: <DataManagement />,
    auth: authRoles.adminhr,
  },
  {
    path: "/Maintenance/Attendancemanagement",
    element: <AttendanceManagement />,
    auth: authRoles.adminhr,
  },
  {
    path: "/Maintenance/TimekeepingManagement",
    element: <TimekeepingManagement />,
    auth: authRoles.adminhr,
  },
];

export default maintenanceRoutes;
